import { Component, Input, OnInit } from '@angular/core';
import { PropertyAnalysisService } from '../../services';
import * as Parse from 'parse';

@Component({
    selector: 'app-property-snapshot-analysis',
    templateUrl: './property-snapshot-analysis.component.html',
    styleUrls: ['./property-snapshot-analysis.component.scss']
})
export class PropertySnapshotAnalysisComponent implements OnInit {
    @Input() property: Parse.Object = new Parse.Object('property');
    @Input() viewSetting: '' | 'sales' | 'acquisition' | 'tc' = '';

    constructor(public propertyAnalysis: PropertyAnalysisService) {
    }

    ngOnInit() {
    }

}
